/** Nearest ancestor that creates a scrollport. `overlay` is the legacy WebKit computed value. */
export function findScrollParent(zone: HTMLElement): HTMLElement {
  let element: HTMLElement | null = zone.parentElement;
  while (element && element !== document.documentElement) {
    const { overflow, overflowY } = window.getComputedStyle(element);
    if (/auto|scroll|overlay/.test(overflow + overflowY)) return element;
    element = element.parentElement;
  }
  return document.documentElement;
}

/** Zone's top edge in scroll-parent content coordinates, independent of its offset parent. */
export function zoneTopInScrollParent(zone: HTMLElement, scrollParent: HTMLElement): number {
  const zoneRect = zone.getBoundingClientRect();
  if (scrollParent === document.documentElement) {
    return zoneRect.top + (document.documentElement.scrollTop || document.body.scrollTop);
  }
  return zoneRect.top - scrollParent.getBoundingClientRect().top + scrollParent.scrollTop;
}

export function isZoneFullyVisible(zone: HTMLElement, scrollParent: HTMLElement): boolean {
  const zoneRect = zone.getBoundingClientRect();
  const parentTop = scrollParent === document.documentElement ? 0 : scrollParent.getBoundingClientRect().top;
  const parentBottom = parentTop + scrollParent.clientHeight;
  return zoneRect.top >= parentTop - 1 && zoneRect.bottom <= parentBottom + 1;
}
